// src/config/cloudinary.js
// Builds Cloudinary URLs. Components never call this directly – use src/config/media.js or src/utils/media.js.
// Account number (1–5) -> cloud name, read from frontend .env or defaults

const CLOUDS = {
  1: process.env.REACT_APP_CLD_ACC1 || "du8qkug1w",
  2: process.env.REACT_APP_CLD_ACC2 || "nawmhne5",
  3: process.env.REACT_APP_CLD_ACC3 || "novmvscq",
  4: process.env.REACT_APP_CLD_ACC4 || "dklpvbfc",
  5: process.env.REACT_APP_CLD_ACC5 || "z55m8tii",
};

// Default transformations
const DEFAULTS = {
  image: "f_auto,q_auto",
  video: "q_auto,vc_auto",
};

const hasExtension = (id) => /\.[a-z0-9]{2,5}$/i.test(id);

export function cldUrl(item, { w, t } = {}) {
  if (!item) return "";
  const { acc, type = "image", id } = item;
  const cloud = CLOUDS[acc];
  if (!cloud || !id) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(`[cloudinary] missing cloud name for account ${acc} or empty id`, item);
    }
    return "";
  }
  const transform = [t || DEFAULTS[type], w ? `w_${w},c_limit` : null]
    .filter(Boolean)
    .join("/");
  const file = type === "video" && !hasExtension(id) ? `${id}.mp4` : id;
  return `https://res.cloudinary.com/${cloud}/${type}/upload/${transform}/${file}`;
}

export function cldPoster(item, w = 600) {
  if (!item || item.type !== "video") return "";
  const base = item.id.replace(/\.[a-z0-9]{2,5}$/i, "");
  return cldUrl({ ...item, id: `${base}.jpg` }, { t: `so_1,q_auto,w_${w},c_limit` });
}

export { CLOUDS };
